
import CatalogSource from "@/api/CatalogSource.js";

export const productModal = {

    state() {
        return {
            product: null,
            showModal: false,
        }
    },

    mutations: {
        showProductModal(state, product) {
            state.product = product;
            state.showModal = true;

            window?.dataLayer?.push({
                "ecommerce": {
                    "currencyCode": "RUB",
                    "detail": {
                        "products": [
                            {
                                "id": product.product_id,
                                "name": product.name,
                                "price": parseInt(product.price_raw) || 0,
                                brand: "Краснодарский парень",
                                "variant": product.constructor ? "Конструктор" : "Стандарт",
                                "list": "Catalog",
                                "position": 1
                            }
                        ]
                    }
                }
            });

        },
        setShowProductModal(state, value) {
            state.showModal = value;
        }
    },
    getters: {
        isModalShow: (state) => {
            return  state.showModal;
        },
    },
    actions: {

    },
    namespaced: true
}
